import React, { useEffect, useRef, useState } from "react";
import "./Login.css";
import AuthService from "../services/AuthService";
import { useSearchParams, Link } from "react-router-dom";

function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("pending"); // pending | success | error
  const [message, setMessage] = useState("Verifying your email…");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      if (!token) {
        setStatus("error");
        setMessage("Missing verification token.");
        return;
      }
      try {
        await AuthService.verifyEmail(token);
        setStatus("success");
        setMessage("Your email is verified. You can now sign in.");
      } catch (err) {
        setStatus("error");
        setMessage(err?.message || "Verification failed or the link has expired.");
      }
    })();
  }, [token]);

  return (
    <div className="auth-page">
      <div className="auth-bg" />
      <div className="auth-shell">
        <div className="auth-card">
          <h2 className="auth-title">Email verification</h2>
          <p className="auth-text">{message}</p>
          {status !== "pending" && (
            <div className="auth-links">
              <Link to="/login">Go to sign in</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
